<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-55">
      <div class="container pb-0">
        <div class="area_wrap">
          <div class="text_wrap caution">
            <div class="tw_item">
              <div class="tw_title">
                <h2>수술 예약 환자 입원 안내</h2>
                <span>(2020년 5월 기준. 병원 사정에 따라 변경될 수 있습니다.)</span>
<!--                <p>★ 코로나 바이러스 유행으로 보호자는 1명으로 제한합니다. (당분간 면회 금지) ★</p>-->
                <p>* 입원해서 수술 받기로 하신 분은 수술 당일에 6층 입원실로 바로 오세요.  *</p>
              </div>
              <div class="tw_content title">
                <p>수술을 앞두고 걱정이 많으실 것으로 생각됩니다만, 저희 땡큐서울의원는 갑상선-두경부외과 수술 전문 의원으로서,
                  안전하고 정확한 수술을 위해 항상 최선을 다하고 있습니다. (2019년 한 해 동안 930건 이상의 입원수술을 안전하게 시행했습니다.)</p>
                <p>예약하신 수술 일정에 차질없이 수술이 이루어 질 수 있도록 최선을 다하고 있습니다만, 병실 사정이나 담당 원장님의 스케쥴이 급작스럽게 변경되는 경우,
                  혹은 수술 전 추가 검사가 필요한 경우에는 불가피하게 입원 및 수술 날짜가 변경될 수 있습니다.</p>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_title">
                <h2>입원 전 준비사항</h2>
              </div>
              <div class="tw_content another">
                <p class="red">금식: 수술 하루 전날 저녁식사 후 자정(밤12시)부터 금식하십시오.</p>
                <div class="tw_sub">
                  <span class="red dotMark">물도 드시면 안 됩니다. (껌, 사탕도 금지)</span>
                  <span class="red dotMark">술과 담배는 최소 1주일 전부터 중단</span>
                  <span class="referMark">고혈압약은 수술 당일 아침에 소량의 물과 함께 섭취하시고 내원하시기 바랍니다.</span>
                  <span class="dotMark pb-0">당뇨약은 복용하지 마세요.</span>
                </div>
                <p>평소 아스피린(아스트릭스), 와파린(쿠마딘), 플라빅스(클로피도그)등과 같은 혈액 순환제, 혈액 응고억제제를 복용하시는 경우 미리 알려주시기 바랍니다.</p>
                <p>당뇨, 고혈압 등의 기저질환이 있으신 분은 미리 알려주시기 바랍니다.</p>
                <p>기타 복용중인 약물이 있으시면 사전에 말씀해 주시기 바랍니다.</p>
                <p class="red">평소에 드시던 약은 입원할 때 가져 오셔야 합니다.</p>
                <p>화장은 간단한 스킨로션만 가능하고, 남성분의 경우 면도 후 입원 부탁드립니다.</p>
                <p>콘택트렌즈는 착용하지 마시기 바랍니다.</p>
                <p>악세사리(귀걸이, 목걸이, 피어싱 등)는 모두 제거하고 오시기 바랍니다.</p>
                <p>손톱, 발톱 매니큐어 및 젤 네일은 지우고 오시기 바랍니다. (외래 시술에는 해당 없습니다.)</p>
                <p>귀중품 도난 시 책임지지 않습니다. 귀중품은 집에 두고 오시기 바랍니다.</p>
              </div>
            </div>
<!--            <div class="tw_item">-->
<!--              <div class="tw_title">-->
<!--                <h2>입원 병실 소개</h2>-->
<!--              </div>-->
<!--              <div class="tw_content">-->
<!--                <p>VIP실 2실, 1인실 2실, 2인실 2실로 총 8병상을 보유하고 있습니다. 병상수가 적어 선호하는 병실을 항상 맞춰드릴 수 없음을 양해 부탁드립니다.</p>-->
<!--                <p class="pb-0">병실료 안내: 모든 병실은 상급병실로 차액(비급여)이 발생합니다.</p>-->
<!--                <div class="tw_sub">-->
<!--                  <span class="referMark">1박 병실료: VIP실 23만원, 1인실 19만원, 2인실 15만원</span>-->
<!--                  <span class="referMark">당일 퇴원 병실료: VIP실 18만원, 1인실 14만원, 2인실 10만원</span>-->
<!--                </div>-->
<!--                <p class="pb-0">퇴원시간: 오전 퇴원은 오전 9~10시, 오후 퇴원은 4~5시입니다.</p>-->
<!--                <div class="tw_sub">-->
<!--                  <span class="red">(당일 퇴원시 입원한 시각으로부터 6시간 뒤 퇴원해야 입원으로 처리됩니다.)</span>-->
<!--                </div>-->
<!--                <p>입원 관련하여 필요한 서류가 있으면 미리 말씀해 주십시오. 다만, 조직검사 후 정확한 진단명 기입이 필요한 서류(진단서 등)의 경우에는 수술 1주일 경과 후 조직검사 결과가 나온 후에,-->
<!--                 외래에서 서류 신청을 해 주시기 바랍니다.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="tw_item">-->
<!--              <div class="tw_title">-->
<!--                <h2>입원 전 준비사항</h2>-->
<!--              </div>-->
<!--              <div class="tw_content another">-->
<!--                <p class="red">금식: 수술 전날 자정(밤 12시)부터 금식하십시오.</p>-->
<!--                <div class="tw_sub">-->
<!--                  <span class="red dotMark">물도 드시면 안 됩니다. (껌, 사탕도 금지)</span>-->
<!--                  <span class="red dotMark">술과 담배는 최소 1주일 전부터 중단</span>-->
<!--                  <span class="referMark">고혈압약은 수술 당일 아침에 소량의 물과 함께 섭취하시고 내원하시기 바랍니다.</span>-->
<!--                  <span class="dotMark pb-0">당뇨약은 복용하지 마세요.</span>-->
<!--                </div>-->
<!--                <p>평소 아스피린(아스트릭스), 와파린(쿠마딘), 플라빅스(클로피도그)등과 같은 혈액 순환제, 혈액 응고억제제를 복용하시는 경우 미리 알려주시기 바랍니다.</p>-->
<!--                <p>당뇨, 고혈압 등의 기저질환이 있으신 분은 미리 알려주시기 바랍니다.</p>-->
<!--                <p>기타 복용중인 약물이 있으시면 사전에 말씀해 주시기 바랍니다.</p>-->
<!--                <p class="red">평소에 드시던 약은 입원할 때 가져 오셔야 합니다.</p>-->
<!--                <p>손톱, 발톱 매니큐어 및 젤 네일은 지우고, 악세사리(귀걸이, 목걸이, 피어싱 등)은 모두 제거하고 오시기 바랍니다.</p>-->
<!--                <p>화장은 간단한 스킨로션만 가능하고, 남성분의 경우 면도 후 입원 부탁드립니다.</p>-->
<!--                <p>콘택트렌즈는 착용하지 마시기 바랍니다.</p>-->
<!--                <p>귀중품 도난 시 책임지지 않습니다. 귀중품은 집에 두고 오시기 바랍니다.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="tw_item">-->
<!--              <div class="tw_title">-->
<!--                <h2>입원시 준비 물품</h2>-->
<!--              </div>-->
<!--              <div class="tw_content another">-->
<!--                <p>물컵, 물통, 세면도구(수건포함)등 개인용품(치약, 칫솔 포함)을 준비해서 오세요.</p>-->
<!--                <p>전열기구는 병원에서 사용할 수 없습니다.</p>-->
<!--                <p>가습기, 이동식 히터는 병원에 비치되어 있습니다. 가져오실 필요 없습니다.</p>-->
<!--                <p>보호자분은 베개, 담요 1개씩만 제공되며, 보호자 슬리퍼는 가지고 오세요.</p>-->
<!--                <div class="tw_sub">-->
<!--                  <span class="pl-12 pb-0">(환자용 슬리퍼는 제공됩니다.)</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="tw_item">-->
<!--              <div class="tw_title">-->
<!--                <h2>주차</h2>-->
<!--              </div>-->
<!--              <div class="tw_content another dot">-->
<!--                <p>건물 주차장이 협소하여, 중대형 차량 및 SUV차량은 주차가 불가능합니다.</p>-->
<!--                <p>건물 주차장에 주차가 가능한 차량에 한해, 입원 수술 환자의 경우,-->
<!--                  1박(24시간) 주차비를 병원에서 지원해 드리고, 이후에는 하루 1만원씩-->
<!--                  추가됩니다. (면회객 주차는 1시간만 무료) </p>-->
<!--                <p>건물 주차장의 발렛비 2,000원은 차량 이용객 부담입니다.</p>-->
<!--                <p>가급적 대중교통을 이용해 주시고, SUV차량이나 중대형 세단으로 병원-->
<!--                  건물 주차장에 주차가 불가능한 경우, 인근 삼흥빌딩 (서울시 강남구-->
<!--                  테헤란로 329, 선릉역 5번 출구 신한은행 건물) 건물 뒤편 주차장에-->
<!--                  주차하시면, 주차비를 일부 보조해 드립니다. (퇴원 후 외래 진료시 영수증-->
<!--                  지참하여 가져오시면 15,000원까지만 지원합니다.)-->
<!--                </p>-->
<!--                <div class="tw_sub">-->
<!--                  <span class="pl-12 pb-0">(ex) 모든 SUV차량, G80, G90, 에쿠스, K9, BMW 7시리즈, 벤츠 S-class,-->
<!--                  아우디A8, A7 등</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="tw_item last">
              <div class="tw_content another">
                <h4>땡큐서울의원</h4>
                <h4>서울특별시 강남구 테헤란로 408 대치빌딩 4, 5, 6층</h4>
                <h4>선릉역 1번 출구</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      transDate: {
        headerName: '수술 전 주의사항',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    ...mapActions([
    ]),
    callPrev () {
      const currentLocation = document.location.href
      const mainLocate = currentLocation.substring(currentLocation.length, currentLocation.length - 22)
      console.log('주의사항 locate', mainLocate)
      if (sessionStorage.getItem('pathToLoadUnAuth') === mainLocate) {
        if (this.setCount) {
          this.$router.push('/info/hospitalInfo')
        } else {
          history.go(1)
        }
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
